import React from "react";

class HomeClock extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			time: Date.now(),
			start: app.startTime,
			end: app.endTime
		};
	}

	componentDidMount() {
		this.interval = setInterval(() => this.tick(), 1000);
	}

	componentWillUnmount() {
		clearInterval(this.interval);
	}

	tick() {
		this.setState({
			time: Date.now(),
			start: app.startTime,
			end: app.endTime
		});
	}

	render() {
		const now = this.state.time;
		const start = this.state.start;
		const end = this.state.end;

		let seconds, minutes, hours, days;
		let status;
		let progress;
		let you;

		function zeroPad(value, length) {
			return String(value).padStart(length, "0");
		}

		function setTime(time) {
			time = Math.floor(time / 1000);
			seconds = zeroPad(time % 60, 2);

			time = Math.floor(time / 60);
			minutes = zeroPad(time % 60, 2);

			time = Math.floor(time / 60);
			hours = zeroPad(time % 24, 2);

			time = Math.floor(time / 24);
			days = zeroPad(time, 2);
		}

		function getDate(time) {
			return new Date(time).toString().split(" ").slice(1, 5).join(" ").slice(0, -3);
		}

		if (!start || !end) {
			status = "Loading...";
			seconds = "--";
			minutes = "--";
			hours = "--";
			days = "--";
			progress = 0;
			you = { left: "-24px" };
		} else if (now < start) {
			setTime(start - now);

			status = "until CTF begins";

			progress = 0;
			you = { left: "-24px" };
		} else if (now < end) {
			setTime(end - now);

			status = "until CTF ends";

			progress = (now - start) / (end - start);
			you = { left: progress * 100 + "%" };
		} else {
			seconds = "--";
			minutes = "--";
			hours = "--";
			days = "--";

			status = "CTF has ended";

			progress = 1;
			you = { right: "-24px" };
		}

		return (
			<div className="home-clock">
				<div className="time">
					<div>
						<span className="value">{days}</span>
						<span className="label">Days</span>
					</div>
					<div>
						<span className="value">{hours}</span>
						<span className="label">Hours</span>
					</div>
					<div>
						<span className="value">{minutes}</span>
						<span className="label">Minutes</span>
					</div>
					<div>
						<span className="value">{seconds}</span>
						<span className="label">Seconds</span>
					</div>
				</div>
				<span className="status">{status}</span>
				<div className="timeline">
					<span className="start">{getDate(start)}</span>
					<div className="progress" style={{ width: progress * 100 + "%" }}></div>
					<div className="you" style={you}></div>
					<span className="end">{getDate(end)}</span>
				</div>
			</div>
		);
	}
}

class HomePage extends React.Component {
	render() {
		return <main>
			<h1>Spooktober miniCTF 2020</h1>
			<HomeClock />
			<div className="columns">
				<div className="column">
					<center><img src="pumpa.png" alt="en pumpa" class="pumpa" /></center>

					<p>Välkommen till Spooktober mini-CTF 2020! Föreningen Kodsport Sverige har under oktober nått 500 medlemmar på sin chattserver på Discord och därmed bestämt sig för att fira med massor av event. Se mer info om Spooktober  <a href="https://www.kodsport.se/spooktober.html">här</a>.</p>

					<p>Mini-CTF:en är del av säkerhetshelgen den 17-18 oktober. Under lördagen sänds det föreläsningar om CTF på vår kanal på <a href="https://www.youtube.com/channel/UCViZaX5UOzyvgXpjxglJMcQ">YouTube</a>. Dessa kan vara användbara att se som förberedelse inför CTF:en! Och på söndagen så hålls den här Mini-CTF:en som du läser om nu. Den pågår mellan 10:00-18:00. Man tävlar individuellt.</p>

					<p>En Capture The Flag (CTF) tävling går ut på att man får ett par IT-säkerhetsrelaterade problem där det gäller att hitta en flagga. Flaggan är en textsträng som i den här tävlingen kommer ha formatet <code>SSM{"{"}...{"}"}</code>. När man hittar en flagga skicka man sedan in den på den här plattformen. Denna tävling kommer att fokusera på CTF-kategorierna "reverse engineering" och "binary exploitation/pwn".</p>

					<h2>Joina vår discordchatt</h2>
					<center><a href="https://discord.gg/m6pcEYp" target="_blank">Discord invite här</a></center>
				</div>
				<div className="divider"></div>
				<div className="column">
					<h2>Regler</h2>
					<ul>
						<li>Denna CTF spelas individuellt.</li>
						<li>Det är förbjudet att diskutera problemlösningar och ledtrådar med andra medans tävlingen pågår.</li>
						<li>Det är förbjudet att attackera CTF platformen. Detta inkluderar brute-forcing av flaggor.</li>
						<li>Respektera problemservrarna. Skapa inte stor trafik till problemen, inga kräver att man skickar mycket data för att få flaggan.</li>
						<li>Det är förbjudet att störa andra personers förmåga att lösa problem.</li>
						<li>Det är förbjudet att ha mer än ett konto på CTF platformen.</li>
					</ul>
					<h2>Priser</h2>
					<p>Prisutdelningen sker på följande vis:</p>
					<p>För att kunna vinna pris måste du vara medlem i föreningen Kodsport, vilket du kan gratis bli <a href="https://ebas.ungaforskare.se/signups/index/63">här</a>. Varje deltagare får 1 lott för varje "easy" problem de har löst, 2 lotter för "medium" och 3 för "hard". Sedan lottas priserna ut bland alla deltagare med minnst 4 lotter (max 1 pris per person). Lottningen sker från potten med alla deltagares lotter, alltså har man därför större chans att vinna desto mer man löser! Om detta var förvirrande finns det lite kod <a href="/priser.py">här</a>.</p>
					<p>Själva priserna eller antalet priser har inte bestämts än.</p>
				</div>
			</div>
		</main>;
	}
}

export default HomePage;
